import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CheckBoxSharedModule } from '../../atoms/checkbox/checkbox.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';

import { CreditCardListElementSharedComponent } from './credit-card-list-element.component';

@NgModule({
    declarations: [
        CreditCardListElementSharedComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CheckBoxSharedModule,
        IconSharedModule
    ],
    exports: [
        CreditCardListElementSharedComponent
    ]
})

export class CreditCardListElementSharedModule {}
